// src/pages/TransferPendingRecord/TransferPendingRecordSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { approveTransfer, fetchTransferPendingRecord } from "./TransferPendingRecordThunk";

const initialState = {
  list: [],
  loading: false,
  filters: {
    filterType: "All",
    recordType: "without item",
    fromDate: null,
    toDate: null,
  },
};

const transferPendingRecordSlice = createSlice({
  name: "transferPendingRecord",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTransferPendingRecord.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTransferPendingRecord.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchTransferPendingRecord.rejected, (state) => {
        state.loading = false;
      })
      .addCase(approveTransfer.fulfilled, (state, action) => {
  // remove approved voucher from pending list
  state.list = state.list.filter((r) => r.t_id !== action.payload);
});
  },
});

export const { setFilters } = transferPendingRecordSlice.actions;
export default transferPendingRecordSlice.reducer;
